import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

interface VendorInfoResponse {
  vendor?: {
    id: number;
    name: string | null;
  };
  error?: {
    message: string;
  };
}

interface TipVendorResponse {
  success: boolean;
  error?: {
    message: string;
  };
}

export async function getVendorInfo(
  loginKey: string,
  eventId: number,
  qrCode: string,
) {
  return post<VendorInfoResponse>(API_ENDPOINTS.GET_VENDOR, {
    login_key: loginKey,
    event: eventId,
    qr_code: qrCode,
  });
}

export async function tipVendor(
  loginKey: string,
  eventId: number,
  amountCents: number,
  qrCode: string,
) {
  return post<TipVendorResponse>(API_ENDPOINTS.TIP_VENDOR, {
    login_key: loginKey,
    event: eventId,
    amount_cents: amountCents,
    qr_code: qrCode,
  });
}

export default {
  getVendorInfo,
  tipVendor,
};
